import { getDB } from '../core';
import type { FolderItem, FolderDataLink } from '@/types';
import { deleteDataItem } from './dataActions';

export async function addFolder(folder: FolderItem): Promise<void> {
  const db = await getDB();
  await db.put('folders', folder);
}

export async function updateFolder(folder: FolderItem): Promise<void> {
  const db = await getDB();
  await db.put('folders', folder);
}

export async function getAllFolders(): Promise<FolderItem[]> {
  const db = await getDB();
  return db.getAll('folders');
}

export async function deleteFolder(id: string): Promise<void> {
  const db = await getDB();
  await db.delete('folders', id);
  const links = await db.getAllFromIndex('folderLinks', 'by-folder', id);
  for (const link of links) {
    await db.delete('folderLinks', link.id);
    await deleteDataItem(link.dataId);
  }
  // Delete child folders recursively
  const children = await db.getAllFromIndex('folders', 'by-parent', id);
  for (const child of children) await deleteFolder(child.id);
}

export async function addFolderLink(link: FolderDataLink): Promise<void> {
  const db = await getDB();
  await db.put('folderLinks', link);
}

export async function getFolderLinks(folderId: string): Promise<FolderDataLink[]> {
  const db = await getDB();
  return db.getAllFromIndex('folderLinks', 'by-folder', folderId);
}

export async function getFolderLink(id: string): Promise<FolderDataLink | undefined> {
  const db = await getDB();
  return db.get('folderLinks', id);
}

export async function updateFolderLink(link: FolderDataLink): Promise<void> {
  const db = await getDB();
  await db.put('folderLinks', link);
}

export async function deleteFolderLink(id: string): Promise<void> {
  const db = await getDB();
  await db.delete('folderLinks', id);
}
